<div class="main-content error-handling">
  <div class="container text-center h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-12 col-md-10 col-xl-8">
        <h2 class="text-red font-weight-normal border-bottom mb-4 pb-4">
          <i class="material-icons mi-inline mr-2" style="font-size: 48px">warning</i>
          <span>Reedge is offline</span>
        </h2>
        <a href="/">
          <button class="btn btn-primary btn-capsule mx-auto">
            Retry<i class="material-icons mi-inline ml-4">subdirectory_arrow_right</i>
          </button>
        </a>
      </div>
    </div>
  </div>
</div>
